import { useEffect, useState, useRef } from 'react'
import { inject, observer } from 'mobx-react';
import FormMaster from '../FormMaster'
import { CommonService, DocumentService } from "../../../services";
import { Modal, Button, ModalAlert, FormLoading } from '../../../components'
import DataGrid, { Paging, Column, Scrolling, Editing, Selection, RequiredRule } from 'devextreme-react/data-grid';
import { isEmpty, get } from 'lodash';
import { CogIcon, PlusIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next'

let firstRender = false
const Document = inject("authenStore", "masterStore")(observer((props) => {
  const { t } = useTranslation(['documents', 'common'])
  let authenStore = props.authenStore
  let masterStore = props.masterStore
  let { getAccountAuth } = authenStore // STATE
  let { setMasterStore } = masterStore
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const gridRef: any = useRef(null);
  const [modal, setModal]: any = useState({
    show: false,
    data: {},
    docs: []
  })
  const [loading, setLoading]: any = useState(false)
  const [loadingDoc, setLoadingDoc] = useState({ visible: false, tip: "กำลังโหลด" })
  const [openModalDoc, setOpenModalDoc]: any = useState(false)
  const [docSelected, setDocSelected]: any = useState([])
  const [docLists, setDocLists]: any = useState([])
  const [masterOptions, setMasterOptions]: any = useState({ doc: [] })
  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    status: "",
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: [],

    }
  })

  useEffect(() => {
    if (firstRender || !isEmpty(getAccountAuth)) {
      CommonService.getMasterData(auth, "doc")
        .then((res: any) => {
          let doc = res.result.doc.map((item) => ({ doc_name: item.doc_name, doc_code: item.doc_code }))
          setMasterOptions({ ...masterOptions, doc })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, content: `Load master data : ${err}` }
          })
        })
    }
    else
      firstRender = true
  }, [getAccountAuth])

  useEffect(() => {
    openModalDoc && getDocs()
  }, [openModalDoc])

  const clearForm = () => {
    setDocSelected([])
    setModal({
      show: false,
      data: {},
      docs: []
    })
  }

  //#region  MANAMGE DOCUMENT
  const getDocs = () => {
    setLoadingDoc({ ...loading, visible: true, tip: 'loading' })
    DocumentService.getDocs(auth)
      .then((res: any) => {
        let { code, message, result, sys_message } = res?.data
        if (code === 200) {
          setDocLists(result)
        }
        else {
          setDocLists([])
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoadingDoc({ ...loading, visible: false })
      })
      .catch((err) => {
        setDocLists([])
        setLoadingDoc({ ...loading, visible: false })
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }

  const manageDoc = (action = "", data) => {
    setLoadingDoc({ ...loading, visible: true, tip: 'saving' })

    if (action === "insert") {
      DocumentService.addDoc(auth, {
        doc_code: data?.doc_code,
        doc_name: data?.doc_name,
      })
        .then((res: any) => {
          let { code, message, sys_message } = res.data
          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              status: "",
              title: t('common:saved_successfully'),
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            getDocs()
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              status: "",
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoadingDoc({ ...loading, visible: false })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoadingDoc({ ...loading, visible: false })
        })
    }
    else if (action === "update") {
      DocumentService.updateDoc(auth, {
        doc_id: data?.doc_id,
        doc_code: data?.doc_code,
        doc_name: data?.doc_name,
      })
        .then((res: any) => {
          let { code, message, sys_message } = res.data
          if (code === 200) {
            setOptionAlert({
              ...optionAlert,
              type: "success",
              show: true,
              status: "",
              title: t('common:saved_successfully'),
              description: { visible: false, type: "text", content: " ", contentLists: [] }
            })
            getDocs()
          }
          else {
            setOptionAlert({
              ...optionAlert,
              type: "danger",
              show: true,
              status: "",
              title: "ผิดพลาด",
              description: { visible: true, type: "text", content: `${message} ${sys_message}` }
            })
          }
          setLoadingDoc({ ...loading, visible: false })
        })
        .catch((err) => {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${err}` }
          })
          setLoadingDoc({ ...loading, visible: false })
        })
    }
  }

  const deleteDoc = (doc_id) => {
    DocumentService.deleteDoc(auth, doc_id)
      .then((res: any) => {
        let { code, message, sys_message } = res
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: t('common:delete_success'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          getDocs()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            action: {
              id: "",
              name: ""
            },
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
      })
  }
  //#endregion

  const updateDocSet = () => {
    setLoading(true)
    let { data } = modal
    DocumentService.updateDocSet(auth, {
      func_id: data?.id,
      doc_list: docSelected
    })
      .then((res: any) => {
        let { code, message, sys_message } = res.data
        if (code === 200) {
          setOptionAlert({
            ...optionAlert,
            type: "success",
            show: true,
            status: "",
            title: t('common:saved_successfully'),
            description: { visible: false, type: "text", content: " ", contentLists: [] }
          })
          setMasterStore({ isRefreshData: true })
          clearForm()
        }
        else {
          setOptionAlert({
            ...optionAlert,
            type: "danger",
            show: true,
            status: "",
            title: "ผิดพลาด",
            description: { visible: true, type: "text", content: `${message} ${sys_message}` }
          })
        }
        setLoading(false)
      })
      .catch((err) => {
        setOptionAlert({
          ...optionAlert,
          type: "danger",
          show: true,
          action: {
            id: "",
            name: ""
          },
          title: "ผิดพลาด",
          description: { visible: true, type: "text", content: `${err}` }
        })
        setLoading(false)
      })
  }

  const onSave = () => {
    setOptionAlert({
      ...optionAlert,
      type: "confirm",
      title: t('common:confirm'),
      show: true,
      description: {
        visible: true,
        type: "text",
        content: t('common:save_the_data'),
        contentLists: []
      }
    })
  }

  return <>
    <FormMaster
      title={t('document_settings')}
      cardExtra={<Button
        text={t('manage_documents')}
        icon={<CogIcon />}
        iconPosition='start'
        onClick={() => setOpenModalDoc(true)}
      />}
      tableConfig={{
        key: "id",
        hiddenAddButton: true,
        apiPath: "doc_set/list",
        allowDelete: {
          visible: false,
          key: "",
          apiPath: ""
        },
        optionDeleteFag: true,
        defaultColumn: [],
        columns: [
          {
            dataField: 'no',
            caption: t('no'),
            width: 60,
            alignment: "center",
            allowFiltering: false
          },
          {
            dataField: 'func_name',
            caption: t('screen'),
          },
          {
            dataField: 'doc_count',
            caption: t('number_of_documents'),
          },
          {
            dataField: 'updated_by',
            caption: t('edit_by'),
          }
        ],
        exportExcel: {
          fileName: t('manage_documents'),
          columnConfig: [
            { label: t('no'), value: 'no' },
            { label: t('screen'), value: 'func_name' },
            { label: t('number_of_documents'), value: 'doc_count' },
            { label: t('edit_by'), value: 'updated_by' }
          ]
        }
      }}
      modalConfig={{
        visible: false,
        title: "",
        required: [],
        fieldTypeNumber: [],
        paramName: "",
        apiPath: {
          "get": '',
          "post": '',
          "put": ''
        },
        elements: []
      }}
      onEdit={(data) => {
        let dt = data.modalConfig.dataSelectRow
        const getDocName = (doc_code) => {
          let doc = masterOptions.doc.find((item) => item.doc_code === doc_code)
          if (doc) return doc?.doc_name
        }

        let docLists: any = [], docSelected: any = []
        dt?.doc_list.forEach((doc_code, id) => {
          let doc_name = getDocName(doc_code)
          docLists.push({ id, doc_code, doc_name })
          docSelected.push(doc_code)
        });

        setDocSelected(docSelected)
        setModal({ ...modal, show: true, data: dt, docs: docLists })
      }}
    />

    <Modal
      title={{
        text: t('document_settings'),
        description: <>
          {t('screen')} : {modal?.data?.func_name}
        </>
      }}
      open={modal.show}
      maskClosable={true}
      contentPadding="p-0"
      width='lg:w-2/4 sm:4/4'
      onClosed={() => clearForm()}
      onOk={() => onSave()}
    >
      <FormLoading loading={loading} tip='saving'>
        <div className="space-y-2" style={{ padding: 20 }}>
          <label className="block text-sm font-medium text-gray-700 mb-1">{t('select_document_items')}</label>
          <DataGrid
            dataSource={masterOptions.doc}
            keyExpr="doc_code"
            showBorders={true}
            allowColumnReordering={true}
            columnAutoWidth={false}
            hoverStateEnabled={true}
            height={300}
            defaultSelectedRowKeys={docSelected}
            onSelectionChanged={(e) => setDocSelected(e.selectedRowKeys)}
          >
            <Scrolling columnRenderingMode="virtual" />
            <Selection
              mode="multiple"
              allowSelectAll={true}
              showCheckBoxesMode="always"
            />
            <Paging enabled={false} />
            <Column dataField="doc_code" caption={t('document_code')} />
            <Column dataField="doc_name" caption={t('document_name')} />

          </DataGrid>
        </div>
      </FormLoading>
    </Modal>

    <Modal
      title={{ text: t('manage_documents') }}
      open={openModalDoc}
      maskClosable={true}
      contentPadding="p-0"
      width='lg:w-2/4 sm:4/4'
      onClosed={() => clearForm()}
      onOk={() => {
        setOptionAlert({
          ...optionAlert,
          action: {
            id: "",
            name: "update_fuel_set"
          },
          type: "confirm",
          title: t('common:confirm'),
          show: true,
          description: {
            visible: true,
            type: "text",
            content: t('common:save_the_data'),
            contentLists: []
          }
        })
      }}
      extra={<Button
        text={t('common:add_data')}
        icon={<PlusIcon />}
        size="sm"
        type="white"
        iconPosition='start'
        onClick={() => gridRef.current.instance.addRow()}
      />}
      footer={<Button
        text={t('common:btn_close')}
        width="w-20"
        onClick={() => setOpenModalDoc(false)}
      />
      }
    >
      <FormLoading loading={loadingDoc.visible} tip={loadingDoc.tip}>
        <div className="space-y-2" style={{ padding: 20 }}>
          <DataGrid
            ref={(ref) => gridRef.current = ref}
            dataSource={docLists}
            keyExpr="id"
            showBorders={true}
            allowColumnReordering={true}
            columnAutoWidth={false}
            hoverStateEnabled={true}
            height={400}
            onSaving={(e) => {
              if (!isEmpty(e.changes)) {
                let change = e.changes[0]
                let { key, type, data } = change
                if (type === "insert") {
                  manageDoc("insert", data)
                }
                else if (type === "update") {
                  let currentDoc = docLists.find((item) => item.id === key)
                  manageDoc("update", {
                    doc_id: key,
                    doc_code: get(data, 'doc_code', currentDoc?.doc_code),
                    doc_name: get(data, 'doc_name', currentDoc?.doc_name)
                  })
                }
                else if (type === "remove") {
                  deleteDoc(key)
                }

              }
            }}
          >
            <Scrolling columnRenderingMode="virtual" />
            <Paging enabled={false} />
            <Editing
              mode="row"
              allowUpdating={true}
              allowDeleting={true}
              texts={{
                editRow: t('edit'),
                deleteRow: t('delete'),
                cancelRowChanges: t('cancel'),
                saveRowChanges: t('save')
              }} />
            <Column
              dataField="no"
              caption={t('no')}
              width={60}
              alignment="center"
              allowEditing={false}
              allowFiltering={false}
              allowSorting={false}
            />
            <Column dataField="doc_code" caption={t('document_code')} >
              <RequiredRule />
            </Column>
            <Column dataField="doc_name" caption={t('document_name')} >
              <RequiredRule />
            </Column>
          </DataGrid>
        </div>
      </FormLoading>
    </Modal>


    <ModalAlert
      {...optionAlert}
      onOk={() => {
        let { type } = optionAlert
        if (type === "confirm") updateDocSet()

        setOptionAlert({ ...optionAlert, show: false })
      }}
      onCancel={() => {
        setOptionAlert({ ...optionAlert, show: false })
      }}
    />
  </>
}))

export default Document